// Module
var code = "<div class=rca-thanks-modal><h3>Thanks!</h3><p>To interact with this page, please ask <span>{{$ctrl.lead.primaryClient.fullName}}&nbsp;</span>to add you as a collaborator on this event.</p><button class=\"btn button-primary\" type=button ng-click=$ctrl.close()>Ok</button></div>";
// Exports
module.exports = code;